export const CDRDetails = (builder) => ({
    CDRDetails: builder.mutation({
        query: ({ mode, search, startDate, endDate, status, page, limit }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/cdrDetails',
                method: 'GET',
                params: { mode, search, startDate, endDate, status, page, limit },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});